export default __webpack_public_path__ + "static/media/mail.6b88ae3f.svg";